import { FC } from 'react';
import { StripeBillingInterval } from '@/__generated__/graphql';
import {
  streamPriceLabelContainer,
  streamPriceLabelHighlighted,
} from '@/components/streams/stream-tag/stream-price-label.css.ts';
import { formatIntervalShort } from '@/utils/paid-data.ts';

export const StreamPriceLabel: FC<{
  price: number;
  isStartingPrice?: boolean;
  variant?: 'primary' | 'secondary';
  subscribed?: boolean;
  interval?: StripeBillingInterval;
  intervalCount?: number;
}> = ({
  price,
  isStartingPrice,
  variant = 'primary',
  subscribed,
  interval,
  intervalCount,
}) => {
  const intervalLabel =
    interval && intervalCount
      ? formatIntervalShort(interval, intervalCount)
      : 'month';

  return (
    <div className={streamPriceLabelContainer[variant]}>
      {isStartingPrice ? <span>Starting from </span> : null}
      {subscribed ? <span>Unlocked for </span> : null}
      <span
        className={
          variant === 'primary' ? streamPriceLabelHighlighted : undefined
        }
      >
        ${price}/{intervalLabel}
      </span>
    </div>
  );
};
